import { render } from "./KioskList.vue?vue&type=template&id=7f58314c"
import script from "./KioskList.vue?vue&type=script&lang=js"
export * from "./KioskList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__